import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBars, FaCogs, FaPlus, FaCopy } from 'react-icons/fa';
import { useAuth } from '../../../contexts/AuthContext';
import { usePlan } from '../../../contexts/PlanContext';
import CustomAgentList from './CustomAgentList';
import './Wizard.css';

export default function Wizard({ hideHeader = false, hideSectionTitle = false }) {
  const { user } = useAuth();
  const { planType } = usePlan();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  
  const view = 'Custom Agents'; // Diagnostics disabled
  // const wizardMenuItems = ['Custom Agents', 'Diagnostics'];
  const wizardMenuItems = ['Custom Agents']; // Diagnostics disabled
  
  // Template gallery state for Custom Agents
  const [showTemplates, setShowTemplates] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuSelect = (option) => {
    if (option === 'Custom Agents') {
      navigate('/app/wizard/custom-agents');
    }
    // Diagnostics disabled
    // else if (option === 'Diagnostics') {
    //   navigate('/app/wizard/diagnostics');
    // }
    setMenuOpen(false);
  };

  return (
    <div style={{ background: '#F7F9FC', minHeight: 'calc(100vh - 10px)', width: '100%', borderRadius: '10px 0px 0px 0px', overflowY: 'auto' }}>
      {/* Header only if not hidden */}
      {!hideHeader && (
        <div className="wizard-header-row" style={{ background: 'linear-gradient(120deg, rgba(241, 245, 249, 1) 3%, rgba(219, 234, 254, 1) 37%, rgba(237, 233, 254, 1) 100%)', height: '9vh', padding: '20px 0px 10px 10px', boxShadow: '0 2px 8px rgba(0,0,0,0.03)', marginBottom: 24, alignItems: 'flex-start' }}>
          <div className="wizard-header-left">
            <div style={{ fontSize: 24, fontWeight: 600, padding: 0, margin:0 }}>{view}</div>
          </div>
          <div className="wizard-header-right" style={{ display: 'flex', gap: 8, alignItems: 'center', paddingRight: 10 }}>
            {/* Create Custom Agent button */}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button 
                onClick={() => navigate('/app/wizard/custom-agents/new')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                  fontSize: '12px',
                  fontWeight: '500',
                  background: '#1a6ed8',
                  border: 'none',
                  borderRadius: '6px',
                  color: 'white',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#1d4ed8';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#1a6ed8';
                }}
              >
                <FaPlus style={{ fontSize: '12px' }} /> Create Custom Agent
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Main content */}
      <div className="wizard-container" style={{ background: 'transparent', marginTop: 0, boxShadow: 'none', padding: 0 }}>
        <div className="wizard-content" style={{ background: 'transparent', marginTop: 0, padding: 0 }}>
          {planType === 'Team' ? (
            <CustomAgentList 
              showTemplates={showTemplates}
              onShowTemplatesChange={setShowTemplates}
            />
          ) : (
              <div className="wizard-placeholder" style={{ 
                background: 'transparent', 
                margin: '0 32px', 
                padding: '48px 32px', 
                borderRadius: '12px', 
                boxShadow: 'none',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  background: '#ffffff',
                  borderRadius: '16px',
                  padding: '48px 32px',
                  textAlign: 'center',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  maxWidth: '500px',
                  width: '90%',
                  margin: '0 5px'
                }}>
                  <div style={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    background: '#f5f3ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 30px auto'
                  }}>
                    <FaCogs style={{ fontSize: '3rem', color: '#1a6ed8' }} />
                  </div>
                  
                  <h1 style={{
                    fontSize: '28px',
                    fontWeight: '700',
                    color: '#2d3436',
                    margin: '0 0 20px 0',
                    lineHeight: '1.2'
                  }}>
                    Upgrade to Team Plan
                  </h1>
                  
                  <p style={{
                    fontSize: '16px',
                    color: '#636e72',
                    margin: '0 0 30px 0',
                    lineHeight: '1.5'
                  }}>
                    Custom Agent automation is available exclusively for Team plan users. Upgrade now to automate your sales operations.
                  </p>
                  
                  <button 
                    onClick={() => window.location.href = '/billing'}
                    style={{
                      display: 'inline-block',
                      background: '#1a6ed8',
                      color: '#ffffff',
                      padding: '12px 24px',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: '600',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 2px 8px rgba(139, 92, 246, 0.3)',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#1d4ed8';
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '#1a6ed8';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 2px 8px rgba(139, 92, 246, 0.3)';
                    }}
                  >
                    Upgrade to Team Plan
                  </button>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
} 